import _implicitStylesheets from "./moreResourcesV2.css";
import _implicitScopedStylesheets from "./moreResourcesV2.scoped.css?scoped=true";
import _listingMoreResourcesSectionV2 from "listing/moreResourcesSectionV2";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "resources-grid": true
  },
  key: 0
};
const stc1 = {
  "resources-column": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {k: api_key, c: api_custom_element, i: api_iterator, h: api_element} = $api;
  return [api_element("div", stc0, api_iterator($cmp.columns, function (column) {
    return api_element("div", {
      classMap: stc1,
      key: api_key(1, column.key)
    }, api_iterator(column.sections, function (resourceSection) {
      return api_custom_element("listing-more-resources-section-v2", _listingMoreResourcesSectionV2, {
        props: {
          "resourceSection": resourceSection
        },
        key: api_key(2, resourceSection.type)
      });
    }));
  }))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-j57pke8gvp";
tmpl.legacyStylesheetToken = "undefined-_moreResourcesV2";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
